export const ColumnsIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 2H14V4V12V14H2V12V4V2ZM4 12H7V4H4V12ZM9 12H12V4H9V12Z'
      fill='inherit'
    />
  </svg>
);
